"use client";
import classNames from "classnames";
import { useState } from "react";

import IconArrowUpDown from "@/components/Icon/IconArrowUpDown.svg";

import Image from "next/image";
import DropDown from "@/components/DropDown";
import ProductReview from "@/components/ProductDetails/ProductReview";
import ReviewPagination from "@/components/ProductDetails/ReviewPagination";
import { getReviewsByProduct } from "@/lib/stamped/getReviewsByProduct";

export default function Component({ summaryReiews, productId, ...props }) {
  const [reviewsData, setReviewsData] = useState(props.reviewsData);
  const [startIndexReview, setStartIndexReview] = useState(1);
  const [endIndexReview, setEndIndexReview] = useState(props.reviewsData.data.length);
  const [page, setPage] = useState(1);
  const reviewPageSize = 3;

  const dropdownOptionsReview = [
    {
      value: "highest-rating",
      label: "Highest to lowest rating",
      sortBy: 'reviewRating',
      sortDirection: "desc"
    },
    {
      value: "lowest-rating",
      label: "Lowest to highest rating",
      sortBy: 'reviewRating',
      sortDirection: "asc"
    },
    {
      value: "featured",
      label: "Most recent",
      sortBy: 'dateCreated',
      sortDirection: "desc"
    },
  ];
  const [sortReview, setSortReview] = useState(dropdownOptionsReview[0].value);

  const fetchReviews = async (page, sortKey) => {
    const currentSortOptions = dropdownOptionsReview.find(item => item.value === sortKey);
    let sortBy = currentSortOptions?.sortBy || 'reviewRating'
    let sortDirection = currentSortOptions?.sortDirection || "desc"
    const data = await getReviewsByProduct(productId, page, reviewPageSize, sortBy, sortDirection);
    const start = (page - 1) * reviewPageSize + 1;
    const end = page * reviewPageSize > data.total ? data.total : page * reviewPageSize;
    setStartIndexReview(start);
    setEndIndexReview(end);
    setReviewsData(data);
  };

  const handlePagination = data => {
    setPage(data);
    fetchReviews(data, sortReview);
    window.scrollTo(0, document.getElementById("review-content").offsetTop);
  };

  return (
    reviewsData &&
    reviewsData.data &&
    reviewsData.data.length > 0 && (
      <div>
        <div
          id="review-content"
          className="flex flex-col md:flex-row items-center justify-between pb-0 lg:pb-[22px] pt-3 md:pt-8 lg:pt-[22px] border-t-[1px] border-grey"
        >
          <span className="text-base mb-2 md:mb-0">
            {startIndexReview}-{endIndexReview} of {reviewsData.total} Reviews
          </span>
          <DropDown
            className="w-[286px] bg-white border-[1px] border-grey text-sm"
            value={sortReview}
            options={dropdownOptionsReview}
            rightIcon={<Image src={IconArrowUpDown.src} width={16} height={16} alt="IconArrowUpDown" />}
            size={50}
            onChange={data => {
              setSortReview(data.target.value);
              fetchReviews(page, data.target.value);
            }}
          />
        </div>
        <div>
          {reviewsData.data.map((review, index) => (
            <ProductReview
              key={`product-review-${index}`}
              className={classNames(index && "border-grey border-t-[1px]")}
              review={review}
            />
          ))}
        </div>
        <div>
          {reviewsData.data.length > 0 && (
            <ReviewPagination
              className="mx-auto mb-2 mt-8 lg:mt-[64px]"
              page={page}
              pageSize={reviewPageSize}
              totalCount={reviewsData.total}
              onChange={data => {
                handlePagination(data);
              }}
            />
          )}
        </div>
      </div>
    )
  );
}
